<template>
  <WhitePage :loading="$store.getters.loading">
    <title-bar>新規作成</title-bar>
    <b-form>
      <b-form-group id="password" label="パスワード">
        <b-form-input type="password" v-model="form.password1" />
        <b-form-input type="password" v-model="form.password2" />
      </b-form-group>
      <b-form-group id="nickname" label="愛称">
        <b-form-input v-model="form.nickname" />
      </b-form-group>
      <b-form-group id="nickname" label="PL名"
        description="注意：PL名は登録後変更できません！">
        <b-form-input v-model="form.player" />
      </b-form-group>
      <b-form-group id="keyword" label="呪文"
        description="砂場をひらがなで">
        <b-form-input v-model="form.keyword" />
      </b-form-group>

      <b-button type="button" variant="primary" @click="onSubmit">登録</b-button>
      <response-message ref="response" :value="postMessage" />

    </b-form>
  </WhitePage>
</template>

<script>
import WhitePage from '@/components/WhitePage'
import TitleBar from '@/components/TitleBar'
import ResponseMessage from '@/components/ResponseMessage'
export default {
  components: {
    WhitePage,
    TitleBar,
    ResponseMessage
  },
  data () {
    return {
      form: {
        password1: '',
        password2: '',
        nickname: '',
        player: '',
        keyword: '',
        class: ''
      },
      postMessage: {}
    }
  },
  methods: {
    onSubmit () {
      this.$store.dispatch('new', this.form)
        .then((response) => {
          this.postMessage = response
          if(response.error === '200 OK'){
            this.$store.commit('LOGIN')
            this.$router.push({ path: 'result' })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.init-class {
  border: 2px solid #CCC;

  td {
    border: 1px solid #CCC;
    height: 100px;
  }
}
</style>
